import React from "react";
import "./heading.css";

function Heading({ ad }) {
  return (
    <div className="heading-section">
      <h1>
        {ad.type_of_room} att hyra på{" "}
        {ad.address.charAt(0).toUpperCase() + ad.address.slice(1).toLowerCase()}{" "}
        i {ad.municipality}
      </h1>
    </div>
  );
}

export default Heading;
